import { SurveyRatingQuestion } from "./SurveyRatingQuestion";
import { SurveyTextArea } from "./SurveyTextArea";
import type { GroupLeaderResponse } from "@/utils/validation";

interface SurveyQuestionsProps {
  formData: GroupLeaderResponse;
  onInputChange: (field: keyof GroupLeaderResponse, value: any) => void;
}

export const SurveyQuestions = ({
  formData,
  onInputChange,
}: SurveyQuestionsProps) => {
  console.log('🔍 SurveyQuestions received formData:', formData);
  
  return (
    <div className="space-y-6">
      <SurveyRatingQuestion
        question="Vi hann med alla moment i träffen"
        field="completed_all_moments"
        value={formData.completed_all_moments}
        onChange={(value) => onInputChange('completed_all_moments', value)}
      />

      {(formData.completed_all_moments === "Stämmer inte alls" || 
        formData.completed_all_moments === "Stämmer dåligt") && (
        <SurveyTextArea
          label="Vilka moment missades?"
          field="missing_moments"
          value={formData.missing_moments}
          onChange={(value) => onInputChange('missing_moments', value)}
        />
      )}

      <SurveyRatingQuestion
        question="Föräldrarna var engagerade i diskussionerna"
        field="parent_engagement"
        value={formData.parent_engagement}
        onChange={(value) => onInputChange('parent_engagement', value)}
      />

      <SurveyRatingQuestion
        question="Jag kände mig trygg i att förmedla innehållet"
        field="good_delivery"
        value={formData.good_delivery}
        onChange={(value) => onInputChange('good_delivery', value)}
      />

      <SurveyRatingQuestion
        question="Jag hade tillräcklig kunskap för att svara på föräldrarnas frågor"
        field="sufficient_knowledge"
        value={formData.sufficient_knowledge}
        onChange={(value) => onInputChange('sufficient_knowledge', value)}
      />

      {(formData.sufficient_knowledge === "Stämmer inte alls" || 
        formData.sufficient_knowledge === "Stämmer dåligt") && (
        <SurveyTextArea
          label="Vilken kunskap saknade du?"
          field="missing_knowledge"
          value={formData.missing_knowledge}
          onChange={(value) => onInputChange('missing_knowledge', value)}
        />
      )}

      <SurveyRatingQuestion
        question="Jag lyckades aktivera gruppen"
        field="activated_group"
        value={formData.activated_group}
        onChange={(value) => onInputChange('activated_group', value)}
      />

      <SurveyRatingQuestion
        question="Jag lyckades hålla strukturen"
        field="maintained_structure"
        value={formData.maintained_structure}
        onChange={(value) => onInputChange('maintained_structure', value)}
      />

      <SurveyTextArea
        label="Övriga kommentarer"
        field="other_comments"
        value={formData.other_comments || ""}
        onChange={(value) => onInputChange('other_comments', value)}
        placeholder="Skriv eventuella övriga kommentarer här..."
      />
    </div>
  );
};